import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="scroll-to-error"
export default class extends Controller {
  connect() {
    const firstError = this.element.querySelector('.field_with_errors');
    if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}
